"use client";
import React from "react";
import Link from "next/link";
export default function MachineRental({ data }) {
    return (
        <div className="rental-section machine">
            <h2>I want to rent the {data.name}</h2>
            <p>
                We can help match you with the right floor scrubber for your needs.
            </p>
            <Link href="/floor-scrubber-rental">
                Floor Scrubber Rentals
            </Link>
        </div>
    );
}
